import { useSyncExternalStore } from 'react'

import { subscribeSession, getSessionSnapshot } from '@/core/auth/session/session.store'

export function useSession() {
  return useSyncExternalStore(subscribeSession, getSessionSnapshot, getSessionSnapshot)
}
